import type { FaireProductEntity } from "../../entity_types/product";

export const p_8dggs3n7xj: FaireProductEntity = {
  token: "p_8dggs3n7xj",
  type: "product",
  name: "Cherry Rhinestone Hair Clips Set (4pc/item) | Cute Pretty",
  brandToken: "b_cllfpw8grf",
  brandName: "Tiny Gift Society",
  imageUrl:
    "https://cdn.faire.com/fastly/af238e2c95aff50105a82dfd2f9945f7e08c946077663c91001b018bf9d3a942.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f48e410704c084d757da394548bfa3d084334f33d037f43598b7bb09a4aac655.jpeg",
    "https://cdn.faire.com/fastly/16cacc0c13e676a461872a9c05764ee9d02e4810d584232bb34f57f14892f11f.jpeg",
    "https://cdn.faire.com/fastly/035f3bf9427de00db8887d420fcb58963d1e3b7fe4c8ffa9fca8aad5765d0967.jpeg",
    "https://cdn.faire.com/fastly/8766e8ce924314d15bd93560d0fae99b4df1748b9c51b468ee2fea15ce53a5c0.jpeg",
  ],
  priceDollars: 5.54,
  description:
    "Enhance your hairstyle with our adorable cherry hair clips with colorful rhinestones.\n\nSEO Keywords: Hair accessories set, cherry rhinestone hair clips, novelty style, fashion accessory.\n\nPackaging is clear bag and card.\n\nA perfect table filler for boutiques and small shops.\n\nGreat for:\n- Thank You Gifts\n- Customer Appreciation Gifts\n- Hair Ties / Hair Accessories\n- Table Fillers\n- Sub Boxes (Subscription Boxes)\n- Women Teens Girls\n- Easter, Stocking stuffer, Christmas gifts, Holiday Gifts, Birthday Gifts",
  tags: [],
  msrpDollars: 24.94,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:44.301Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
